'use strict';
require('./UserAccessAdmin.scss');

const React = require('react'),
    {t} = require('services/i18nextWrapper'),
    {map, filter, find} = require('lodash/collection'),
    UserServiceImpl = require('services/UserServiceImpl'),
    SessionStore = require('stores/SessionStore'),
    InventoryStore = require('stores/InventoryStore'),
    ContentUtils = require('utils/ContentUtils'),
    sortBy = require('lodash/collection').sortBy,
    {Toggle} = require('material-ui'),
    SessionActionCreators = require('actions/SessionActionCreators'),
    Notification = require('components/Notification/Notification'),
    NavigationUtils = require('utils/NavigationUtils'),
    AdminScaffoldingGeneric = require('components/Commons/AdminScaffolding/AdminScaffoldingGeneric'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    Loading = require('components/Commons/Loading/Loading'),
    FormGroupDropdown = require('components/Commons/BasicForm/FormGroupDropdown/FormGroupDropdown'),
    Authentication = require('services/Security').Authentication,
    GridItemWithFilter = require('components/Commons/GridItem/GridItemWithFilter'),
    ga = require('react-ga'),
    {Navigation} = require('react-router'),
    {cloneDeep} = require('lodash/lang'),
    get = require('lodash/object').get,
    {groupBy} = require('lodash/collection');

const UserAccessAdmin = React.createClass({displayName: "UserAccessAdmin",

    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

    /**
     * The model wit all local changes from the session.
     */
    modelChanges: [],

    getInitialState() {
        return {
            selectedPermission: null,
            isEditMode: false,
            isPristineForm: true,
            isFetching: true,
            userSelected: null,
            localChanges: []
        };
    },

    componentDidMount() {
        this.fetchUsersAccess();
        ga.pageview('/users-access-admin');
    },

    fetchUsersAccess() {
        const self = this;
        const userSelectedId = NavigationUtils.getQueryParam('userId');


        InventoryStore.fetchIcons(function (icons) {
            SessionStore.fetchUserAccess(function (userInfo) {
                const userPermissionsAllowed = filter(get(userInfo, 'userPermissions'), userPermission => get(userPermission, 'isEnable')) || [];
                const userPermissionFiltered = filter(userPermissionsAllowed, userPermission => get(userPermission, 'user.id') === +userSelectedId);
                const userPermissionsId = map(userPermissionFiltered, userPermission => get(userPermission, 'permissions.id')) || [];
                const users = filter(get(userInfo, 'users'), user => get(user, 'accountEnabled'));
                const permissions = self._filterPermissionForOldGuestUsers(userSelectedId, users, get(userInfo, 'permissions'));

                const permissionsUpdated = map(self._filterAdminPermissions(permissions), permission => {
                    const permissionName = get(permission, 'name');
                    const moduleName = get(permission, 'module');

                    // set all items needed to visualize properly each box
                    const permissionNameWithoutModule = permissionName.replace(moduleName + '_', '');
                    permission.displayName = ContentUtils.formatMessage(permissionNameWithoutModule);
                    permission.isSelected = userPermissionsId.indexOf(get(permission, 'id')) > -1 ? 'YES' : 'NO';
                    permission.iconClassNameField = 'material-icons';
                    permission.iconInnerText = ContentUtils.getIconText(permissionName);

                    return permission;
                });

                self.setState({
                    users,
                    icons: get(icons, 'icons'),
                    permissions: permissionsUpdated,
                    localChanges: [],
                    permissionsPristine: cloneDeep(permissionsUpdated),
                    isPristineForm: true, // reset pristine indicator,
                    userPermissions: get(userInfo, 'userPermissions'),
                    isEditMode: false,
                    isFetching: false,
                    userSelected: find(users, user => get(user, 'id') === +userSelectedId)
                });
            });
        });
    },

    _filterPermissionForOldGuestUsers(userIdSelected, users, permissions) {
        const userTarget = find(users, user => user.id === +userIdSelected);

        const isGuestUser = this._isGuestUser(userTarget);
        const isAdminUser = this._isAdminUser(userTarget);
        if (isGuestUser || isAdminUser) {
            return filter(permissions, permission =>
                get(permission, 'name') !== 'DASHBOARD_EDIT_NOTES'
            );
        } else {
            return permissions;
        }
    },

    _isGuestUser(user) {
        const roles = get(user, 'roles');
        if (ContentUtils.isNotEmptyArray(roles)) {
            return roles.length === 1 && roles[0] === 'USER';
        } else {
            return false;
        }
    },

    _isAdminUser(user) {
        const roles = get(user, 'roles');
        if (ContentUtils.isNotEmptyArray(roles)) {
            return roles.some(role => role === 'ADMIN');
        } else {
            return false;
        }
    },

    _filterAdminPermissions(permissions) {
        return filter(permissions, p => p.module !== 'ADMIN_USER' && p.module !== 'ADMIN_USER_PERMISSION');
    },

    _onChangeUser(evt, index, menuItem) {
        const isNonSelectedUser = index === 0;
        if (isNonSelectedUser) {
            this.setState(prevState => {
                return {
                    userSelected: null,
                    selectedPermission: null,
                    isEditMode: false,
                    localChanges: [],
                    permissions: prevState.permissions.map(p => {
                        p.isChecked = false;
                        p.isSelected = 'NO';
                        return p;
                    })
                };
            }, () => {
                this.transitionTo('user-permissions');
            });
        } else {
            this.setState({
                userSelected: get(menuItem, 'itemModel'),
                selectedPermission: null
            }, () => {
                this.transitionTo('user-permissions', null, {userId: this.state.userSelected.id});
                this.fetchUsersAccess();
            });
        }
    },

    _onCancel() {
        this.setState({
            userSelected: null,
            selectedPermission: null,
            isEditMode: false
        }, this.fetchUsersAccess);
    },

    onSavePermission(item, onSuccess, onFailure) {
        const userSelectedId = NavigationUtils.getQueryParam('userId');
        UserServiceImpl.updatePermissions(userSelectedId, this.state.localChanges, item.isSelected, () => {
            Notification.show(t('user_access_saved_notification'), 'success');

            SessionActionCreators.permissionRequestUpdate(
                ContentUtils.getSession('userNameSession'),
                ContentUtils.getSession('X-Auth-Token'),
                SessionStore.getCurrentApplicantId()
            );

            this.setState({
                userSelected: null,
                selectedPermission: null,
                isEditMode: false
            }, this.fetchUsersAccess);

        }, onFailure);
    },

    isCheckedItem(permission) {
        return permission.isSelected === 'YES';
    },

    isChangedItem(permissionChanged) {
      const permissionAlreadyChanged = find(this.state.localChanges, permission => get(permission, 'iconId') === get(permissionChanged, 'id'));
      return permissionAlreadyChanged !== undefined;
    },

    onCheckItem(permissionChanged) {
        this.setState(prevState => {
            let permissionTarget = find(prevState.permissions, permission => get(permission, 'id') === get(permissionChanged, 'iconId'));
            permissionTarget = SessionStore.onTogglePermission(permissionTarget);
            prevState.permissions = ContentUtils.replace(prevState.permissions, permissionTarget, 'id');
            prevState.localChanges = this.updatePermissions(prevState.localChanges, [permissionTarget]),
            prevState.selectedPermission = permissionTarget;
            return prevState;
        });
    },
    
    _onToggle(moduleName) {
        this.setState(prevState => {
            const { permissions, isEditMode, localChanges: oldLocalChanges } = prevState;
            const localChanges = (permissions || []).filter(permission => permission.module === moduleName);
            const somePermissionOff = localChanges.some(permission => permission.isSelected === 'NO');
            if (somePermissionOff) {
                localChanges.forEach(permission => SessionStore.forcePermission(permission, true));
            } else {
                localChanges.forEach(permission => SessionStore.forcePermission(permission, false));
            }
            return {
                permissions: ContentUtils.replaceAll(permissions, localChanges, 'id'),
                localChanges: this.updatePermissions(oldLocalChanges, localChanges),
                isEditMode: !isEditMode
            };
        });
    },
    
    updatePermissions(oldPermissions, newPermissions) {
        const newPermissionChangedIds = newPermissions.map(permission => permission.id);
        const oldLocalChangesWithoutRepeated = oldPermissions.filter(permission => newPermissionChangedIds.indexOf(permission.id) === -1);
        return oldLocalChangesWithoutRepeated.concat(newPermissions);
    },
    
    render() {
        if (this.state.isFetching) {
            return React.createElement(Loading, null);
        } else {
            const messages = {
                changeSuccessMessage: t('user_access_change_success_message'),
                changeFailureMessage: t('user_access_change_failure_message'),
                deleteSuccessMessage: t('user_access_delete_message'),
                addSuccessMessage: t('user_access_add_success_message'),
                addFailureMessage: t('user_access_add_failure_message')
            };
            const dictionary = getDictionary(t);
            const contextHolder = this.getContextHolderInstance();
            const {isEditMode, users, permissions, userSelected, localChanges} = this.state;
            const permissionByModules = groupBy(permissions, 'module');
            const isCurrentUserAdmin = this._isAdminUser(userSelected);
            
            const modulesName = Object.keys(permissionByModules);
            const modulesNameSorted = sortBy(modulesName);
            const modulesNameSortedWithoutDashboard = modulesNameSorted.filter(moduleName => moduleName !== 'DASHBOARD');
            
            const permissionByModulesEl = isCurrentUserAdmin ? null : map(modulesNameSortedWithoutDashboard, moduleName => {
                const premissionsValue = get(permissionByModules, moduleName);
                const sortedPermissionsValue = ContentUtils.sortIcons(premissionsValue);
                const isToggleOn = this.state.permissions.filter(permission => permission.module === moduleName).every(permission => permission.isSelected === 'YES');
                return (
                    React.createElement("div", null, 
                        React.createElement("div", {className: "user-access-admin__header"}, 
                            React.createElement("h2", {className: "user-access-admin__header-text"}, dictionary[moduleName]), 
                            React.createElement("div", {className: "user-access-admin__header-toggle"}, 
                                React.createElement(Toggle, {
                                  name: "isConfirmProduct", 
                                  toggled: isToggleOn, 
                                  onToggle: this._onToggle.bind(this, moduleName)}
                                )
                            )
                        ), 
                        React.createElement("div", {className: "user-access-admin__boxes"}, 
                            React.createElement(GridItemWithFilter, {
                                showSwitcher: true, 
                                filterHidden: true, 
                                items: sortedPermissionsValue, 
                                isCheckedItem: this.isCheckedItem, 
                                isChangedItem: this.isChangedItem, 
                                onCheckItem: this.onCheckItem, 
                                displayNameField: "displayName", 
                                iconInnerText: "iconInnerText", 
                                iconClassNameField: "iconClassNameField", 
                                idField: "id", 
                                initialFilterText: "", 
                                keepSelectedSorting: false, 
                                dictionary: dictionary}
                            )
                        )
                    )
                );
            });

            const formFieldsEl = [
                React.createElement(FormGroupDropdown, {
                    items: users, 
                    operationsHolder: contextHolder, 
                    readerAttribute: "username", 
                    name: t('label_user'), 
                    value: userSelected, 
                    isEditMode: isEditMode, 
                    onEnter: this.__onEnterPress, 
                    onChange: this._onChangeUser}
                )
            ];

            const isDashboardToggleOn = this.state.permissions.filter(permission => permission.module === 'DASHBOARD').every(permission => permission.isSelected === 'YES');
            return (
                React.createElement(AdminScaffoldingGeneric, {
                    messages: messages, 
                    moduleName: "ADMIN_USER_PERMISSION", 
                    title: t('user_access_user_level'), 
                    contextHolder: contextHolder, 
                    value: !ContentUtils.isNullOrEmpty(localChanges), 
                    fetchItems: this.fetchUsersAccess, 
                    onCancel: this._onCancel, 
                    headerFields: formFieldsEl, 
                    addEnterKeyDown: this.__addEnterKeyDown, 
                    onChange: this.onSavePermission, 
                    keepSelectedSorting: false
                }, 
                    isCurrentUserAdmin ? null : React.createElement("div", null, 
                        React.createElement("div", {className: "user-access-admin__header is-first"}, 
                            React.createElement("h2", {className: "user-access-admin__header-text"}, dictionary['DASHBOARD_SHOW']), 
                            React.createElement("div", {className: "user-access-admin__header-toggle"}, 
                                React.createElement(Toggle, {
                                  name: "isConfirmProduct", 
                                  toggled: isDashboardToggleOn, 
                                  onToggle: this._onToggle.bind(this, 'DASHBOARD')}
                                )
                            )
                        ), 
                        React.createElement("div", {className: "user-access-admin__boxes"}, 
                            React.createElement(GridItemWithFilter, {
                              showSwitcher: true, 
                              filterHidden: true, 
                              items: ContentUtils.sortIcons(get(permissionByModules, 'DASHBOARD')), 
                              isCheckedItem: this.isCheckedItem, 
                              isChangedItem: this.isChangedItem, 
                              onCheckItem: this.onCheckItem, 
                              displayNameField: "displayName", 
                              iconInnerText: "iconInnerText", 
                              iconClassNameField: "iconClassNameField", 
                              idField: "id", 
                              initialFilterText: "", 
                              keepSelectedSorting: false, 
                              dictionary: dictionary}
                            )
                        )
                    ), 
                    isCurrentUserAdmin ? React.createElement("h2", {style: {
                        margin: '0 auto',
                        padding: '50px',
                        display: 'flex',
                        justifyContent: 'center'
                    }, className: "user-access-admin__subtitle"}, t('user_access_no_allow_change_admin_message')) : null, 
                    permissionByModulesEl
                )
            );
        }
    }
});

const getDictionary = (t) => ({
    'ADMIN_TANK_SHOW': t('user_access_widget_tank_show'),
    'ADMIN_TANK_NEW': t('user_access_widget_tank_new'),
    'ADMIN_TANK_EDIT': t('user_access_widget_tank_edit'),
    'ADMIN_TANK_DELETE': t('user_access_widget_tank_delete'),
    'ADMIN_TANK_PRINT_REPORT': t('user_access_widget_print_report'),
    'ADMIN_BEER_STYLE_SHOW': t('user_access_widget_style_show'),
    'ADMIN_BEER_STYLE_NEW': t('user_access_widget_style_new'),
    'ADMIN_BEER_STYLE_EDIT': t('user_access_widget_style_edit'),
    'ADMIN_BEER_STYLE_DELETE': t('user_access_widget_style_delete'),
    'ADMIN_BEER_STYLE_BREWING_ICONS': t('user_access_widget_style_brewing_icons'),
    'ADMIN_BEER_STYLE_FERMENTING_ICONS': t('user_access_widget_style_fermenting_icons'),
    'ADMIN_BEER_STYLE_PACKAGING_ICONS': t('user_access_widget_style_packaging_icons'),
    'ADMIN_BEER_STYLE_DUPLICATE': t('user_access_widget_style_duplicate'),
    'ADMIN_BEER_STYLE_CONFIGURATION_NEW': t('user_access_widget_style_configuration_new'),
    'ADMIN_BEER_STYLE_CONFIGURATION_EDIT': t('user_access_widget_style_configuration_edit'),
    'ADMIN_BEER_STYLE_CONFIGURATION_DELETE': t('user_access_widget_style_configuration_delete'),
    'ADMIN_TASK_SHOW': t('user_access_widget_task_show'),
    'ADMIN_TASK_NEW': t('user_access_widget_task_new'),
    'ADMIN_TASK_EDIT': t('user_access_widget_task_edit'),
    'ADMIN_TASK_DELETE': t('user_access_widget_task_delete'),
    'ADMIN_ICON_SHOW': t('user_access_widget_icon_show'),
    'ADMIN_ICON_EDIT': t('user_access_widget_icon_edit'),
    'ADMIN_ITEM_SHOW': t('user_access_widget_item_show'),
    'ADMIN_ITEM_NEW': t('user_access_widget_item_new'),
    'ADMIN_ITEM_EDIT': t('user_access_widget_item_edit'),
    'ADMIN_ITEM_DELETE': t('user_access_widget_item_delete'),
    'ADMIN_ITEM_DUPLICATE': t('user_access_widget_purchase_duplicate'),
    'ADMIN_PURCHASE_SHOW': t('user_access_widget_purchase_show'),
    'ADMIN_PURCHASE_NEW': t('user_access_widget_purchase_new'),
    'ADMIN_PURCHASE_ITEM_NEW': t('user_access_widget_purchase_new_item'),
    'ADMIN_PURCHASE_EDIT': t('user_access_widget_purchase_edit'),
    'ADMIN_PURCHASE_DELETE': t('user_access_widget_purchase_delete'),
    'ADMIN_PURCHASE_DUPLICATE': t('user_access_widget_purchase_duplicate'),
    'ADMIN_PURCHASE_VIEW_ORDER': t('user_access_widget_purchase_view_order'),
    'ADMIN_PURCHASE_PRINT_REPORT': t('user_access_widget_purchase_print_report'),
    'ADMIN_PURCHASE_SEND_PENDING_ORDER': t('user_access_widget_purchase_send_pending_order'),
    'ADMIN_PURCHASE_NEW_ITEM': t('user_access_widget_purchase_new_item'),
    'ADMIN_PURCHASE_ITEM_EDIT': t('user_access_widget_purchase_edit_item'),
    'ADMIN_PURCHASE_ITEM_DELETE': t('user_access_widget_purchase_delete_item'),
    'ADMIN_PURCHASE_CONFIRM_RECEIVE': t('user_access_widget_purchase_confirm_receive'),
    'ADMIN_SALE_SHOW': t('user_access_widget_sale_show'),
    'ADMIN_SALE_NEW': t('user_access_widget_sale_new'),
    'ADMIN_SALE_EDIT': t('user_access_widget_sale_edit'),
    'ADMIN_SALE_DELETE': t('user_access_widget_sale_delete'),
    'ADMIN_SALE_SEND_ORDER': t('user_access_widget_sale_send_order'),
    'ADMIN_SALE_CONFIRM_ORDER': t('user_access_widget_sale_confirm_order'),
    'ADMIN_SALE_VIEW_ORDER': t('user_access_widget_sale_view_order'),
    'ADMIN_SALE_PRINT_REPORT': t('user_access_widget_sale_print_report'),
    'ADMIN_SALE_ITEM_NEW': t('user_access_widget_sale_item_new'),
    'ADMIN_SALE_ITEM_EDIT': t('user_access_widget_sale_item_edit'),
    'ADMIN_SALE_ITEM_DELETE': t('user_access_widget_sale_item_delete'),
    'ADMIN_INVENTORY_AND_TRANSFERS_SHOW': t('user_access_widget_inventory_and_transfer_show'),
    'ADMIN_INVENTORY_AND_TRANSFERS_TRANSFER_SHOW': t('user_access_widget_inventory_and_transfer_transfer_show'),
    'ADMIN_INVENTORY_AND_TRANSFERS_ADJUST_SHOW': t('user_access_widget_inventory_and_transfer_adjust_show'),
    'ADMIN_PRODUCT_SHOW': t('user_access_widget_product_show'),
    'ADMIN_PRODUCT_NEW': t('user_access_widget_product_new'),
    'ADMIN_PRODUCT_EDIT': t('user_access_widget_product_edit'),
    'ADMIN_PRODUCT_DELETE': t('user_access_widget_product_delete'),
    'ADMIN_PRODUCT_ICON_SHOW': t('user_access_widget_product_icon_show'),
    'ADMIN_PRODUCT_ICON_NEW': t('user_access_widget_product_icon_new'),
    'ADMIN_PRODUCT_ICON_EDIT': t('user_access_widget_product_icon_edit'),
    'ADMIN_PRODUCT_ICON_DELETE': t('user_access_widget_product_icon_delete'),
    'ADMIN_PRODUCT_ITEMS_SUBSTRACTION_SHOW': t('user_access_widget_product_item_substraction_show'),
    'ADMIN_PRODUCT_ITEMS_SUBSTRACTION_NEW': t('user_access_widget_product_item_substraction_new'),
    'ADMIN_PRODUCT_ITEMS_SUBSTRACTION_EDIT': t('user_access_widget_product_item_substraction_edit'),
    'ADMIN_PRODUCT_ITEMS_SUBSTRACTION_DELETE': t('user_access_widget_product_item_substraction_delete'),
    'ADMIN_PRODUCT_ITEMS_ADDITION_SHOW': t('user_access_widget_product_item_addition_show'),
    'ADMIN_PRODUCT_ITEMS_ADDITION_NEW': t('user_access_widget_product_item_addition_new'),
    'ADMIN_PRODUCT_ITEMS_ADDITION_EDIT': t('user_access_widget_product_item_addition_edit'),
    'ADMIN_PRODUCT_ITEMS_ADDITION_DELETE': t('user_access_widget_product_item_addition_delete'),
    'ADMIN_PRODUCT_DUPLICATE_SHOW': t('user_access_widget_product_duplicate_show'),
    'ADMIN_LOCATION_SHOW': t('user_access_widget_location_show'),
    'ADMIN_LOCATION_NEW': t('user_access_widget_location_new'),
    'ADMIN_LOCATION_EDIT': t('user_access_widget_location_edit'),
    'ADMIN_LOCATION_DELETE': t('user_access_widget_location_delete'),
    'ADMIN_VENDOR_SHOW': t('user_access_widget_vendor_show'),
    'ADMIN_VENDOR_NEW': t('user_access_widget_vendor_new'),
    'ADMIN_VENDOR_EDIT': t('user_access_widget_vendor_edit'),
    'ADMIN_VENDOR_DELETE': t('user_access_widget_vendor_delete'),
    'ADMIN_VENDOR_SET_ITEMS': t('user_access_widget_vendor_set_items'),
    'ADMIN_VENDOR_SET_CONTACTS': t('user_access_widget_vendor_set_contacts'),
    'ADMIN_VENDOR_SET_ADDRESS': t('user_access_widget_vendor_set_address'),
    'ADMIN_VENDOR_ADDRESS_SHOW': t('user_access_widget_address_show'),
    'ADMIN_VENDOR_ADDRESS_NEW': t('user_access_widget_address_new'),
    'ADMIN_VENDOR_ADDRESS_EDIT': t('user_access_widget_address_edit'),
    'ADMIN_VENDOR_ADDRESS_DELETE': t('user_access_widget_address_delete'),
    'ADMIN_VENDOR_CONTACT_SHOW': t('user_access_widget_contact_show'),
    'ADMIN_VENDOR_CONTACT_NEW': t('user_access_widget_contact_new'),
    'ADMIN_VENDOR_CONTACT_EDIT': t('user_access_widget_contact_edit'),
    'ADMIN_VENDOR_CONTACT_DELETE': t('user_access_widget_contact_delete'),
    'ADMIN_VENDOR_ITEMS_SHOW': t('user_access_widget_items_show'),
    'ADMIN_VENDOR_ITEMS_NEW': t('user_access_widget_items_new'),
    'ADMIN_VENDOR_ITEMS_EDIT': t('user_access_widget_items_edit'),
    'ADMIN_VENDOR_ITEMS_DELETE': t('user_access_widget_items_delete'),
    'ADMIN_CUSTOMER_SHOW': t('user_access_widget_customer_show'),
    'ADMIN_CUSTOMER_NEW': t('user_access_widget_customer_new'),
    'ADMIN_CUSTOMER_EDIT': t('user_access_widget_customer_edit'),
    'ADMIN_CUSTOMER_DELETE': t('user_access_widget_customer_delete'),
    'ADMIN_CUSTOMER_ADDRESS_SHOW': t('user_access_widget_customer_address_show'),
    'ADMIN_CUSTOMER_ADDRESS_NEW': t('user_access_widget_customer_address_new'),
    'ADMIN_CUSTOMER_ADDRESS_EDIT': t('user_access_widget_customer_address_edit'),
    'ADMIN_CUSTOMER_ADDRESS_DELETE': t('user_access_widget_customer_address_delete'),
    'ADMIN_CUSTOMER_CONTACT_SHOW': t('user_access_widget_customer_contact_show'),
    'ADMIN_CUSTOMER_CONTACT_NEW': t('user_access_widget_customer_contact_new'),
    'ADMIN_CUSTOMER_CONTACT_EDIT': t('user_access_widget_customer_contact_edit'),
    'ADMIN_CUSTOMER_CONTACT_DELETE': t('user_access_widget_customer_contact_delete'),
    'ADMIN_CUSTOMER_PRICE_SHOW': t('user_access_widget_customer_price_show'),
    'ADMIN_CUSTOMER_PRICE_NEW': t('user_access_widget_customer_price_new'),
    'ADMIN_CUSTOMER_PRICE_EDIT': t('user_access_widget_customer_price_edit'),
    'ADMIN_CUSTOMER_PRICE_DELETE': t('user_access_widget_customer_price_delete'),
    'ADMIN_REPORT_SHOW': t('user_access_widget_report_show'),
    'ADMIN_REPORT_BY_BATCH_NUMBER': t('user_access_widget_report_batch_number_show'),
    'ADMIN_REPORT_BY_ITEM_TRANSACTION': t('user_access_widget_report_items_show'),
    'ADMIN_REPORT_BY_PRODUCT': t('user_access_widget_report_group_item_show'),
    'ADMIN_REPORT_BY_TASK': t('user_access_widget_report_tasks_show'),
    'DASHBOARD_EDIT_NOTES': t('user_access_widget_dashboard_edit_notes'),
    'DASHBOARD_EDIT_ALL': t('user_access_widget_dashboard_edit_all'),
    'DASHBOARD_EDIT_ALL_WITHOUT_DATES': t('user_access_widget_dashboard_edit_all_without_date'),
    'ADMIN_TANK': t('user_access_widget_title_admin_tank'),
    'ADMIN_BEER_STYLE': t('user_access_widget_title_admin_beer_style'),
    'ADMIN_TASK': t('user_access_widget_title_admin_task'),
    'ADMIN_ICON': t('user_access_widget_title_admin_icon'),
    'ADMIN_ITEM': t('user_access_widget_title_admin_item'),
    'ADMIN_PURCHASE_ITEM': t('user_access_widget_title_admin_purchase_item'),
    'ADMIN_CUSTOMER': t('user_access_widget_title_admin_customer'),
    'ADMIN_INVENTORY_AND_TRANSFERS': t('user_access_widget_title_admin_inventory_and_transfers'),
    'ADMIN_PRODUCT': t('user_access_widget_title_admin_product'),
    'ADMIN_LOCATION': t('user_access_widget_title_admin_location'),
    'ADMIN_VENDOR': t('user_access_widget_title_admin_vendor'),
    'ADMIN_SALE': t('user_access_widget_title_admin_sale'),
    'ADMIN_USER': t('user_access_widget_title_admin_user'),
    'ADMIN_USER_ACCESS': t('user_access_widget_title_admin_user_access'),
    'ADMIN_PURCHASE': t('user_access_widget_title_admin_purchase_item'),
    'DASHBOARD_SHOW': t('user_access_widget_title_admin_dashboard'),
    'ADMIN_USER_PERMISSION': t('user_access_widget_title_admin_user_access'),
    'ADMIN_BEER_STYLE_CONFIGURATION': t('user_access_widget_title_admin_beer_style_configuration'),
    'ADMIN_REPORT': t('user_access_widget_title_admin_report')
});


module.exports = UserAccessAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/UserAccess/UserAccessAdmin.jsx
 **/